export default __webpack_public_path__ + "722d5a5520e672f845b338686ddef392.png";